import { Box, RangeInput } from "grommet"
import TextInputWithUnit from "./TextInputWithUnit"
import { useCallback, useEffect, useState } from "react"

const RangeInputWithEdit = ({ value, type, unit, onValueChange, ...props }) => {

    const handleChange = useCallback((event) => {
        let newValue = event.target.value;
        if (onValueChange) {
            onValueChange(newValue);
        }
    }, [onValueChange])

    return (
        <Box direction="row" gap="small" align="center">
            <Box basis="70%">
                <RangeInput value={value} onChange={handleChange} {...props} />
            </Box>
            <Box basis="30%" >
                <TextInputWithUnit 
                    name={props.name}
                    value={value}
                    type={type}
                    onChange={handleChange}
                    unit={unit}
                />
            </Box>
        </Box>
    )
}

export default RangeInputWithEdit;